import { render, staticRenderFns } from "./AncientSampleList.vue?vue&type=template&id=6f575417&scoped=true"
import script from "./AncientSampleList.vue?vue&type=script&lang=js"
export * from "./AncientSampleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f575417",
  null
  
)

export default component.exports